export { default } from 'features/menu/routes/menu-favorite-edit-route';
